var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stock" },
    [
      _c(
        "el-form",
        {
          staticClass: "demo-form-inline",
          attrs: {
            "label-position": "right",
            inline: true,
            model: _vm.orderForm,
            "label-width": "65px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品编码" } },
            [
              _c("el-input", {
                attrs: { placeholder: "商品编码" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchGoodsList.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.orderForm.self_code,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.orderForm,
                      "self_code",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "orderForm.self_code"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "锐锢编码", "label-width": "65px" } },
            [
              _c("el-input", {
                attrs: { placeholder: "锐锢编码" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchGoodsList.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.orderForm.ruigu_code,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.orderForm,
                      "ruigu_code",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "orderForm.ruigu_code"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商品名称", "label-width": "65px" } },
            [
              _c("el-input", {
                attrs: { placeholder: "商品名称" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchGoodsList.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.orderForm.name,
                  callback: function($$v) {
                    _vm.$set(_vm.orderForm, "name", $$v)
                  },
                  expression: "orderForm.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "价格审核状态", "label-width": "95px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.orderForm.audit_status,
                    callback: function($$v) {
                      _vm.$set(_vm.orderForm, "audit_status", $$v)
                    },
                    expression: "orderForm.audit_status"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "待审核", value: "1" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "审核通过", value: "2" } }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "审核不通过", value: "-1" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "分类", "label-width": "65px" } },
            [
              _c("el-input", {
                attrs: { placeholder: "分类" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchGoodsList.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.orderForm.c_name,
                  callback: function($$v) {
                    _vm.$set(_vm.orderForm, "c_name", $$v)
                  },
                  expression: "orderForm.c_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "品牌", "label-width": "65px" } },
            [
              _c("el-input", {
                attrs: { placeholder: "品牌" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchGoodsList.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.orderForm.b_name,
                  callback: function($$v) {
                    _vm.$set(_vm.orderForm, "b_name", $$v)
                  },
                  expression: "orderForm.b_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商品状态", "label-width": "65px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.orderForm.is_enable,
                    callback: function($$v) {
                      _vm.$set(_vm.orderForm, "is_enable", $$v)
                    },
                    expression: "orderForm.is_enable"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "全部", value: "" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "启用", value: "1" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "停用", value: "0" } })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isDeposit
            ? _c(
                "el-form-item",
                { attrs: { label: "商品类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.orderForm.is_deposit,
                        callback: function($$v) {
                          _vm.$set(_vm.orderForm, "is_deposit", $$v)
                        },
                        expression: "orderForm.is_deposit"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "定金购商品", value: "1" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "非定金购商品", value: "0" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.searchGoodsList }
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.exportOrder }
                },
                [_vm._v("导出")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            { name: "show", rawName: "v-show", value: true, expression: "true" }
          ],
          staticClass: "batchbox"
        },
        [
          _c(
            "div",
            { staticClass: "info" },
            [
              _c(
                "el-form",
                {
                  ref: "stockNumForm",
                  staticClass: "demo-form-inline11",
                  attrs: {
                    inline: true,
                    model: _vm.stockNumForm,
                    rules: _vm.rules,
                    "show-message": false,
                    "hide-required-asterisk": true
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "库存数量",
                        prop: "type",
                        "label-width": "70px"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.stockNumForm.type,
                            callback: function($$v) {
                              _vm.$set(_vm.stockNumForm, "type", $$v)
                            },
                            expression: "stockNumForm.type"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "介于", value: "bt" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "小于", value: "lt" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "大于", value: "gt" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "等于", value: "et" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.stockNumForm.type === "bt"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "",
                            prop: "minNum",
                            "label-width": "5px"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "库存数量" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.searchGoodsList.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.stockNumForm.minNum,
                              callback: function($$v) {
                                _vm.$set(_vm.stockNumForm, "minNum", $$v)
                              },
                              expression: "stockNumForm.minNum"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.stockNumForm.type === "bt"
                    ? _c("span", { staticClass: "inline-line" }, [_vm._v("-")])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "", prop: "maxNum", "label-width": "5px" }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "库存数量" },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.searchGoodsList.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.stockNumForm.maxNum,
                          callback: function($$v) {
                            _vm.$set(_vm.stockNumForm, "maxNum", $$v)
                          },
                          expression: "stockNumForm.maxNum"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            background: "none",
                            border: "1px solid #dcdfe6",
                            color: "#999"
                          },
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.searchStockCountHandler }
                        },
                        [_c("i", { staticClass: "el-icon-search" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content:
                              "不支持和其他值一起查询,若设置该项,其他项设置的值会被清空。（如数量、分类等不能同时设置查询）",
                            placement: "bottom",
                            effect: "light"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "el-icon-question",
                            staticStyle: { color: "#999" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticStyle: { color: "#999", "font-size": "10px" } },
                        [_vm._v("\n            (仅支持单一查询)\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-dropdown",
                {
                  staticClass: "batchbtn m-r-10",
                  attrs: {
                    trigger: "click",
                    size: "medium",
                    placement: "bottom"
                  }
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary", size: "small" } },
                    [
                      _vm._v("\n          数据导出\n          "),
                      _c("i", {
                        staticClass: "el-icon-caret-bottom el-icon--right"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function($event) {
                              return _vm.exportData(1)
                            }
                          }
                        },
                        [_vm._v("在售商品导出")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function($event) {
                              return _vm.exportData(2)
                            }
                          }
                        },
                        [_vm._v("下架商品导出")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function($event) {
                              return _vm.exportData(3)
                            }
                          }
                        },
                        [_vm._v("缺货商品导出")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleAddStoragePos }
                },
                [_vm._v("添加库位")]
              ),
              _vm._v(" "),
              _c(
                "el-dropdown",
                {
                  staticClass: "batchbtn",
                  attrs: {
                    trigger: "click",
                    size: "medium",
                    placement: "bottom"
                  }
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary", size: "small" } },
                    [
                      _vm._v("\n          批量设置\n          "),
                      _c("i", {
                        staticClass: "el-icon-caret-bottom el-icon--right"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function($event) {
                              _vm.dialogExelVisible = true
                            }
                          }
                        },
                        [_vm._v("导出模版")]
                      ),
                      _vm._v(" "),
                      _vm.shopStatus === 1 || _vm.shopStatus === -1
                        ? _c(
                            "el-dropdown-item",
                            {
                              nativeOn: {
                                click: function($event) {
                                  _vm.dialogdaoru = true
                                }
                              }
                            },
                            [_vm._v("导入数据")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.shopStatus === -2
                        ? _c(
                            "el-dropdown-item",
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      "店铺已停用，若需维护，请先启用店铺",
                                    placement: "bottom",
                                    effect: "light"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#999" } },
                                    [_vm._v("导入数据")]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function($event) {
                              return _vm.importrecord.apply(null, arguments)
                            }
                          }
                        },
                        [_vm._v("导入记录日志")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择导出模版类型",
            width: "440px",
            "append-to-body": "",
            center: "",
            visible: _vm.dialogExelVisible,
            top: "250px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogExelVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "exportbtnbox" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.exportTemplate(4)
                    }
                  }
                },
                [_vm._v("商品编码")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.exportTemplate(1)
                    }
                  }
                },
                [_vm._v("数量")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.exportTemplate(2)
                    }
                  }
                },
                [_vm._v("待审核价格")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.exportTemplate(3)
                    }
                  }
                },
                [_vm._v("库位")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择导入数据类型",
            width: "440px",
            "append-to-body": "",
            center: "",
            visible: _vm.dialogdaoru,
            top: "250px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogdaoru = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "exportbtnbox" },
            [
              _c(
                "upload-excel-component",
                {
                  staticStyle: {
                    display: "inline-block",
                    "margin-left": "10px"
                  },
                  attrs: {
                    "on-success": function(results) {
                      return _vm.handleSuccess(results, 4)
                    }
                  }
                },
                [_vm._v("商品编码")]
              ),
              _vm._v(" "),
              _c(
                "upload-excel-component",
                {
                  staticStyle: {
                    display: "inline-block",
                    "margin-left": "10px"
                  },
                  attrs: {
                    "on-success": function(results) {
                      return _vm.handleSuccess(results, 1)
                    }
                  }
                },
                [_vm._v("数量")]
              ),
              _vm._v(" "),
              _c(
                "upload-excel-component",
                {
                  staticStyle: {
                    display: "inline-block",
                    "margin-left": "10px"
                  },
                  attrs: {
                    "on-success": function(results) {
                      return _vm.handleSuccess(results, 2)
                    }
                  }
                },
                [_vm._v("待审核价格")]
              ),
              _vm._v(" "),
              _c(
                "upload-excel-component",
                {
                  staticStyle: {
                    display: "inline-block",
                    "margin-left": "10px"
                  },
                  attrs: {
                    "on-success": function(results) {
                      return _vm.handleSuccess(results, 3)
                    }
                  }
                },
                [_vm._v("库位")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请输入需要关联的库位",
            "append-to-body": "",
            center: "",
            visible: _vm.isShowAddStoragePosDialog,
            top: "250px",
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowAddStoragePosDialog = $event
            },
            close: _vm.closeStoragePosDialog
          }
        },
        [
          _c(
            "div",
            { staticClass: "exportbtnbox" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  autosize: "",
                  resize: "none",
                  placeholder: "请输入库位"
                },
                model: {
                  value: _vm.storagePos,
                  callback: function($$v) {
                    _vm.storagePos = $$v
                  },
                  expression: "storagePos"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "add-margin" },
                [
                  _c(
                    "el-button",
                    { on: { click: _vm.closeStoragePosDialog } },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "button-bg-color",
                      attrs: { type: "primary" },
                      on: { click: _vm.saveStoragePosDialog }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("stock-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loadingStock,
            expression: "loadingStock"
          }
        ],
        staticClass: "stockTable",
        attrs: {
          stockTableData: _vm.stockTableData,
          showindex: true,
          templateshow: true
        },
        on: {
          updateTable: _vm.getGoodsList,
          handleShowAddStoragePos: _vm.handleShowAddStoragePos
        }
      }),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-sizes": [10, 50, 100, 200],
          "page-size": _vm.pagesize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.totalCount
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05ca9d89", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ca9d89","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/stock/stock.vue
// module id = null
// module chunks = 